import { EncryptType, NetworkType } from '../../common/util'
import i18n from 'i18next'

/**
 * Created by Tiger on 28/02/2022.
 */

const NETWORK_TYPE_OPTIONS = () => [
  {
    label: i18n.t('ali_iot'),
    value: NetworkType.AliBabaIoT,
    key: 'NETWORK_TYPE_OPTIONS-ALI',
  },
  {
    label: i18n.t('custom_mqtt'),
    value: NetworkType.CustomMQTT,
    key: 'NETWORK_TYPE_OPTIONS-MQTT',
  },
]

const ENCRYPT_TYPE_OPTION = () => [
  {
    label: i18n.t('no_encrypt'),
    value: EncryptType.NoEncrypt,
    key: 'ENCRYPT_TYPE_OPTION-0',
  },
  {
    label: i18n.t('fixed_encrypt'),
    value: EncryptType.FixedEncrypt,
    key: 'ENCRYPT_TYPE_OPTION-1',
  },
]

const REPORT_INTERVAL_OPTIONS = (deviceType) => {
  let options = [
    {
      label: `10 ${i18n.t('minutes')}`,
      value: 10,
      key: 'REPORT_INTERVAL_OPTIONS-10mins',
    },
    {
      label: `15 ${i18n.t('minutes')}`,
      value: 15,
      key: 'REPORT_INTERVAL_OPTIONS-15mins',
    },
    {
      label: `30 ${i18n.t('minutes')}`,
      value: 30,
      key: 'REPORT_INTERVAL_OPTIONS-30mins',
    },
    {
      label: `45 ${i18n.t('minutes')}`,
      value: 45,
      key: 'REPORT_INTERVAL_OPTIONS-45mins',
    },
  ]
  if (deviceType === 'CGDN1' || deviceType === 'CGS1') {
    let extraOptions = [
      {
        label: `1 ${i18n.t('minute')}`,
        value: 1,
        key: 'REPORT_INTERVAL_OPTIONS-1min',
      },
      {
        label: `5 ${i18n.t('minutes')}`,
        value: 5,
        key: 'REPORT_INTERVAL_OPTIONS-5mins',
      },
    ]
    options = extraOptions.concat(options)
  }

  for (let i = 0; i < 24; i++) {
    options.push({
      label: `${i + 1} ${i18n.t('hours')}`,
      value: (i + 1) * 60,
      key: `REPORT_INTERVAL_OPTIONS-${(i + 1) * 60}mins`,
    })
  }

  return [...options]
}

const COLLECT_INTERVAL_OPTIONS = () => {
  const options = [
    {
      label: `1 ${i18n.t('minute')}`,
      value: 1,
      key: 'COLLECT_INTERVAL_OPTIONS-1min',
    },
  ]

  for (let i = 1; i < 13; i++) {
    options.push({
      label: `${i * 5} ${i18n.t('minutes')}`,
      value: i * 5,
      key: `COLLECT_INTERVAL_OPTIONS-${i * 5}mins`,
    })
  }
  return [...options]
}

const BLE_INTERVAL_OPTIONS = () => [
  {
    label: `1 ${i18n.t('second')}`,
    value: 1000,
    key: 'BLE_INTERVAL_OPTIONS-1second',
  },
  {
    label: `2 ${i18n.t('seconds')}`,
    value: 2000,
    key: 'BLE_INTERVAL_OPTIONS-2seconds',
  },
  {
    label: `3 ${i18n.t('seconds')}`,
    value: 3000,
    key: 'BLE_INTERVAL_OPTIONS-3seconds',
  },
  {
    label: `4 ${i18n.t('seconds')}`,
    value: 4000,
    key: 'BLE_INTERVAL_OPTIONS-4seconds',
  },
  {
    label: `5 ${i18n.t('seconds')}`,
    value: 5000,
    key: 'BLE_INTERVAL_OPTIONS-5seconds',
  },
  {
    label: `6 ${i18n.t('seconds')}`,
    value: 6000,
    key: 'BLE_INTERVAL_OPTIONS-6seconds',
  },
]

export {
  NETWORK_TYPE_OPTIONS,
  ENCRYPT_TYPE_OPTION,
  REPORT_INTERVAL_OPTIONS,
  COLLECT_INTERVAL_OPTIONS,
  BLE_INTERVAL_OPTIONS,
}
